import { LogLevel } from "@azure/msal-browser";
// Browser check variables
// If you support IE, our recommendation is that you sign-in using Redirect APIs
// If you as a developer are testing using Edge InPrivate mode, please add "isEdge" to the if check
const ua = window.navigator.userAgent;
const msie = ua.indexOf("MSIE ");
const msie11 = ua.indexOf("Trident/");
const msedge = ua.indexOf("Edge/");
const firefox = ua.indexOf("Firefox");
const isIE = msie > 0 || msie11 > 0;
const isEdge = msedge > 0;
const isFirefox = firefox > 0; // Only needed if you need to support the redirect flow in Firefox incognito
const IS_DEV = window.location.host !== "secure.myeyedr.com";
const b2cEnv = IS_DEV
  ? {
      loginDomain: "logindev.myeyedr.com",
      tenant: "b2cmyeyedrdev",
      tenantId: "b2cmyeyedrdev.onmicrosoft.com",
      clientId: "7b0567f5-26c2-4fc2-98e5-52ca80784d3a",
    }
  : {
      loginDomain: "login.myeyedr.com",
      tenant: "b2cmyeyedr",
      tenantId: "b2cmyeyedr.onmicrosoft.com",
      clientId: "f2a38f35-7a7b-44f5-8459-88c9221c5987",
    };

const authorityBase = `https://${b2cEnv.loginDomain}/${b2cEnv.tenantId}`;

/**
 * Enter here the user flows and custom policies for your B2C application
 * To learn more about user flows, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/user-flow-overview
 * To learn more about custom policies, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/custom-policy-overview
 */
export const b2cPolicies = {
  names: {
    signUpSignIn: "B2C_1A_SIGNINSIGNUP",
    forgotPassword: "B2C_1_reset_v3",
    editProfile: "B2C_1_edit_profile_v2",
  },
  authorities: {
    signUpSignIn: {
      authority: `${authorityBase}/B2C_1A_SIGNINSIGNUP`,
    },
    forgotPassword: {
      authority: `${authorityBase}/B2C_1_reset_v3`,
    },
    editProfile: {
      authority: `${authorityBase}/B2C_1_edit_profile_v2`,
    },
  },
  authorityDomain: b2cEnv.loginDomain,
};

// Config object to be passed to Msal on creation
export const msalConfig = {
  auth: {
    clientId: b2cEnv.clientId,
    authority: b2cPolicies.authorities.signUpSignIn.authority,
    knownAuthorities: [b2cPolicies.authorityDomain],
    redirectUri: "/selector",
    postLogoutRedirectUri: "/",
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: isIE || isEdge || isFirefox,
  },
  system: {
    allowPlatformBroker: false, // Disables WAM Broker
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
    },
  },
};

// Scopes you add here will be prompted for consent during login
export const loginRequest = {
  scopes: [
    "openid",
    "offline_access",
    `${authorityBase}/api/.default`,
  ],
};

/**
 * Enter here the coordinates of your web API and scopes for access token request
 * The current application coordinates were pre-registered in a B2C tenant.
 */
export const apiConfig = {
  scopes: [
    `${authorityBase}/read`,
  ],
  uri: authorityBase,
};
